const isRelease = process.env.VUE_APP_IS_RELEASE == 1

// prettier-ignore
module.exports = {
  // 环境类型
  isRelease: isRelease,

  rtlLangs: ['ar', 'fa', 'he'],

  // 图片地址
  imgHost: isRelease ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',

  // 现有web包 备用
  validWebPackage: ['vavaWeb'],
  // h5包名
  vavaWebPackage: ['com.vava.chat.web'],

  // 现有包
  validPackage: ['echo', 'joychat', 'joyu', 'kiko', 'vava', 'vibeo', 'whonow'],

  // app包名
  // 测试 安卓 苹果
  echoPackage: ['com.example.echo', 'com.chat.whisper', 'com.fh.whisper.chat'],
  // 测试 安卓
  joychatPackage: ['com.owner.chat', 'com.chat.joychat'],
  // 测试 安卓
  joyuPackage: ['com.example.joyu', 'com.mind.joyu'],
  // 安卓测试 安卓正式 ios测试 苹果正式
  kikoPackage: ['com.example.kiko', 'com.live.kiko', 'com.test.moodlink', 'com.date.moodlink'],
  // 测试 安卓
  vavaPackage: ['com.example.gcc', 'com.client.goparty'],
  // 测试 安卓
  vibeoPackage: ['com.example.vibeo', 'com.live.vibeo'],
  // 测试 安卓
  whonowPackage: ['com.example.whonow', 'com.linkup.chat.whonow'],

  // app包名 [测试 安卓 苹果] 简写
  packageNameMap: {
    // echo
    'com.example.echo': 'echo',
    'com.chat.whisper': 'echo',
    'com.fh.whisper.chat': 'echo',
    // joychat
    'com.owner.chat': 'joychat',
    'com.chat.joychat': 'joychat',
    // joyu
    'com.example.joyu': 'joyu',
    'com.mind.joyu': 'joyu',
    // kiko 安卓
    'com.example.kiko': 'kiko',
    'com.live.kiko': 'kiko',
    // kiko ios
    'com.test.moodlink': 'kiko',
    'com.date.moodlink': 'kiko',
    // vava
    'com.example.gcc': 'vava',
    'com.client.goparty': 'vava',
    // vibeo
    'com.example.vibeo': 'vibeo',
    'com.live.vibeo': 'vibeo',
    // whonow
    'com.example.whonow': 'whonow',
    'com.linkup.chat.whonow': 'whonow',
    // h5
    'com.vava.chat.web': 'vavaWeb'
  },

  // ios包
  kikoIosPackages: ['com.test.moodlink', 'com.date.moodlink'],

  // 接口域名 (用于接口调用)
  apiBaseURLecho: isRelease ? 'dewidfp7zx5np.cloudfront.net' : 'd1ttx9a5vofxx7.cloudfront.net',
  apiBaseURLjoychat: isRelease ? 'api.joyme.chat' : 'app.test.camfan.chat',
  apiBaseURLjoyu: isRelease ? 'sev.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
  apiBaseURLkikoIos: isRelease ? 'api.inpulse.cc' : 'inpulse.test.inpulse.cc',
  apiBaseURLkikoAndroid: isRelease ? 'api.inpulse.fun' : 'app.test.inpulse.fun',
  apiBaseURLvava: isRelease ? 'api.camfan.chat' : 'app.test.camfan.chat',
  apiBaseURLvibeo: isRelease ? 'vbi.vervachat.com' : 'vibeo.test.vervachat.com',
  apiBaseURLwhonow: isRelease ? 'dwogpybf1cxs0.cloudfront.net' : 'd31j2n3w70svmb.cloudfront.net',

  // 页面域名 (用于判断包)
  // 正式 测试 测试
  echoHost: ['www.echoapp.chat', 'dewidfp7zx5np.cloudfront.net', 'd1ttx9a5vofxx7.cloudfront.net'],
  // 正式 正式 测试
  joychatHost: ['www.joyme.chat', 'app.joyme.chat', 'dr9gc3kyysxu5.cloudfront.net'],
  // 正式 测试
  joyuHost: ['www.mind-link.chat', 'd30296ri52vin5.cloudfront.net'],
  // 正式 正式 正式 测试
  kikoHost: ['www.kikoapp.chat', 'www.inpulse.fun', 'app.inpulse.fun', 'app.test.inpulse.fun'],
  // 正式 正式 正式 测试
  vavaHost: ['www.vava.chat', 'www.camfan.chat', 'app.camfan.chat', 'app.test.camfan.chat'],
  // 正式 测试
  vibeoHost: ['web.vervachat.com', 'vibeo.test.vervachat.com'],
  // 正式 测试
  whonowHost: ['www.linkup.chat', 'd31j2n3w70svmb.cloudfront.net'],

  // 分享地址 (invite的政策页面 下载页等)
  echoAddress: isRelease ? 'www.echoapp.chat' : 'd1ttx9a5vofxx7.cloudfront.net',
  joychatAddress: isRelease ? 'app.joyme.chat' : 'dr9gc3kyysxu5.cloudfront.net',
  joyuAddress: isRelease ? 'www.mind-link.chat' : 'd30296ri52vin5.cloudfront.net',
  kikoAddress: isRelease ? 'www.kikoapp.chat' : 'app.test.inpulse.fun',
  vavaAddress: isRelease ? 'www.vava.chat' : 'app.test.camfan.chat',
  vibeoAddress: isRelease ? 'web.vervachat.com' : 'vibeo.test.vervachat.com',
  whonowAddress: isRelease ? 'www.linkup.chat' : 'd31j2n3w70svmb.cloudfront.net',

  // 协议头
  schemaMap: {
    default: 'imee://',
    echo: 'echo://',
    joychat: 'joychat://',
    joyu: 'joyu://',
    kiko: 'kiko://',
    vava: 'imee://',
    vibeo: 'vibeo://',
    whonow: 'whonow://'
  },

  defaultClientPath: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page'
  },
  echoClientPath: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page'
  },
  joychatClientPath: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page'
  },
  joyuClientPath: {
    open_web_inside: 'launch_integrated_browser',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_messaging_interface',
    open_customer_service_page: 'contact_client_assistance',
    open_vip_page: 'navigate_to_vip_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'view_user_details',
    open_profile_edit_page: 'begin_profile_adjustment',
    open_discover_page: 'enter_exploration_center',
    open_match_page: 'enter_pairing_screen',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_profit_analytics',
    open_income_detail_page: 'analyze_income_breakdown',
    open_income_daily_report_page: 'verify_daily_income_report',
    open_store_page: 'proceed_to_shop_interface',
    open_in_app_review: 'begin_evaluation_submission_process',
    chat_open_input: 'activate_chat_input_field',
    chat_send_picture: 'send_image_in_chat',
    open_session_page: 'open_message_inbox',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'display_dial_credit_suggestion',
    open_block_list: 'open_block_list',
    open_package_page: 'discover_membership_plans',
    open_new_user_recharge_dialog: 'display_novice_recharge_suggestion',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'validate_male_subscription_level',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'access_welcome_deposit_bonus'
  },
  kikoClientPath: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page'
  },
  vavaClientPath: {
    open_web_inside: 'open_web_inside',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'open_chat_page',
    open_customer_service_page: 'open_customer_service_page',
    open_vip_page: 'open_vip_page',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'open_profile_page',
    open_profile_edit_page: 'open_profile_edit_page',
    open_discover_page: 'open_discover_page',
    open_match_page: 'open_match_page',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'open_income_page',
    open_income_detail_page: 'open_income_detail_page',
    open_income_daily_report_page: 'open_income_daily_report_page',
    open_store_page: 'open_store_page',
    open_in_app_review: 'open_in_app_review',
    chat_open_input: 'chat_open_input',
    chat_send_picture: 'chat_send_picture',
    open_session_page: 'open_session_page',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'open_call_pass_recommend',
    open_block_list: 'open_block_list',
    open_package_page: 'open_package_page',
    open_new_user_recharge_dialog: 'open_new_user_recharge_dialog',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'open_male_level_page',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'open_first_deposit_gift_pack_page'
  },
  vibeoClientPath: {
    open_web_inside: 'launch_web_view',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'enter_chat_interface',
    open_customer_service_page: 'contact_customer_support',
    open_vip_page: 'navigate_to_vip_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'show_user_profile',
    open_profile_edit_page: 'enter_profile_editing',
    open_discover_page: 'explore_discover_tab',
    open_match_page: 'browse_matching_screen',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'access_earnings_overview',
    open_income_detail_page: 'check_earnings_breakdown',
    open_income_daily_report_page: 'view_daily_earnings_report',
    open_store_page: 'go_to_store_interface',
    open_in_app_review: 'trigger_in_app_rating',
    chat_open_input: 'activate_chat_input_field',
    chat_send_picture: 'send_image_in_chat',
    open_session_page: 'open_conversation_list',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'show_call_pass_suggestions',
    open_block_list: 'open_block_list',
    open_package_page: 'view_subscription_packages',
    open_new_user_recharge_dialog: 'show_new_user_recharge_prompt',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'navigate_male_level_info',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'display_first_deposit_bonus'
  },
  whonowClientPath: {
    open_web_inside: 'launch_web_view',
    open_web_outside: 'open_web_outside',
    open_chat_page: 'enter_chat_interface',
    open_customer_service_page: 'contact_customer_support',
    open_vip_page: 'navigate_to_vip_center',
    open_user_verify_page: 'open_user_verify_page',
    open_profile_page: 'show_user_profile',
    open_profile_edit_page: 'enter_profile_editing',
    open_discover_page: 'explore_discover_tab',
    open_match_page: 'browse_matching_screen',
    open_system_page: 'open_system_page',
    open_task_page: 'open_task_page',
    open_income_page: 'access_earnings_overview',
    open_income_detail_page: 'check_earnings_breakdown',
    open_income_daily_report_page: 'view_daily_earnings_report',
    open_store_page: 'go_to_store_interface',
    open_in_app_review: 'trigger_in_app_rating',
    chat_open_input: 'activate_chat_input_field',
    chat_send_picture: 'send_image_in_chat',
    open_session_page: 'open_conversation_list',
    open_discover_post_page: 'open_discover_post_page',
    open_post_detail: 'open_post_detail',
    open_call_pass_recommend: 'show_call_pass_suggestions',
    open_block_list: 'open_block_list',
    open_package_page: 'view_subscription_packages',
    open_new_user_recharge_dialog: 'show_new_user_recharge_prompt',
    start_matching: 'start_matching',
    profile_edit_select_photo: 'profile_edit_select_photo',
    profile_edit_select_video: 'profile_edit_select_video',
    profile_edit_select_hobby: 'profile_edit_select_hobby',
    profile_edit_select_language: 'profile_edit_select_language',
    open_overlay_window_permission: 'open_overlay_window_permission',
    open_male_level_page: 'navigate_male_level_info',
    open_post_publish: 'open_post_publish',
    open_first_deposit_gift_pack_page: 'display_first_deposit_bonus'
  }
}

/** 按包短名注册的 API 域名解析策略；未注册则使用 apiBaseURL${shortName} */
module.exports.apiBaseHostStrategies = {
  kiko(appPackageName, cfg) {
    return cfg.kikoIosPackages.includes(appPackageName) ? cfg.apiBaseURLkikoIos : cfg.apiBaseURLkikoAndroid
  },
}

module.exports.resolveApiBaseHost = function resolveApiBaseHost(appPackageName) {
  const shortName = this.packageNameMap[appPackageName]
  const strategy = this.apiBaseHostStrategies[shortName]
  // 在apiBaseHostStrategies中有的就走策略对象判断，没有就不判断直接去取对应包的
  const host = strategy ? strategy(appPackageName, this) : this[`apiBaseURL${shortName}`]
  return host || this.apiBaseURLvava
}
